export function holeResults(users) {
  return users?.[0]?.holes.reduce((acc, { holePar }) => acc + holePar, 0);
}
